import React from 'react';
import { ArrowRight, Check } from '@phosphor-icons/react';
import { SectionHeading } from './BrandMark';

function ProductCard({ product, tone, onCta, delay }) {
  const dark = tone === 'dark';
  return (
    <article
      className={`relative flex flex-col p-8 sm:p-10 ${
        dark
          ? 'bg-[#0A0A0A] text-[#F8F6F0] shadow-[0_30px_80px_-30px_rgba(10,10,10,0.6)]'
          : 'border border-[#0A0A0A]/10 bg-white text-[#0A0A0A] shadow-[0_30px_80px_-40px_rgba(85,107,47,0.45)]'
      }`}
      data-reveal
      style={{ '--reveal-delay': `${delay}ms` }}
    >
      <span className={`absolute inset-x-0 top-0 h-1 ${dark ? 'bg-gradient-to-r from-[#D4AF37] via-[#F0D477] to-[#D4AF37]' : 'bg-[#556B2F]'}`} aria-hidden="true" />
      <p className={`font-landing text-[0.7rem] font-semibold uppercase tracking-[0.3em] ${dark ? 'text-[#D4AF37]' : 'text-[#556B2F]'}`}>
        {product.tag}
      </p>
      <h3 className="mt-4 font-display text-3xl font-semibold sm:text-4xl">{product.name}</h3>
      <p className={`mt-3 font-display text-lg italic ${dark ? 'text-[#CFC8BE]' : 'text-[#4A4740]'}`}>{product.tagline}</p>

      <ul className="mt-8 space-y-4">
        {product.features.map((feature) => (
          <li key={feature} className="flex gap-3 font-landing text-[0.95rem] leading-relaxed">
            <Check size={18} weight="bold" className={`mt-1 shrink-0 ${dark ? 'text-[#D4AF37]' : 'text-[#556B2F]'}`} aria-hidden="true" />
            <span className={dark ? 'text-[#E6E1D6]' : 'text-[#2B2924]'}>{feature}</span>
          </li>
        ))}
      </ul>

      <div className="mt-auto pt-10">
      <button
        type="button"
        onClick={onCta}
        className={`group inline-flex h-14 items-center justify-center gap-3 px-8 font-landing text-[0.78rem] font-semibold uppercase tracking-[0.16em] transition-transform hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${
          dark
            ? 'bg-gradient-to-b from-[#E2C15A] to-[#C39B22] text-[#0A0A0A] focus-visible:ring-[#D4AF37] focus-visible:ring-offset-[#0A0A0A]'
            : 'bg-[#0A0A0A] text-[#F8F6F0] focus-visible:ring-[#556B2F] focus-visible:ring-offset-white'
        }`}
      >
        {product.cta}
        <ArrowRight size={18} weight="bold" className="transition-transform group-hover:translate-x-1" />
      </button>
      </div>
    </article>
  );
}

export function ProductsSection({ copy, onOpenErp, onRequestDemo }) {
  const section = copy.products;
  return (
    <section id="products" className="scroll-mt-16 bg-[#F8F6F0] py-24 lg:py-32" aria-labelledby="products-title">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading eyebrow={section.eyebrow} title={section.title} subtitle={section.subtitle} />
        <h2 id="products-title" className="sr-only">{section.title}</h2>
        <div className="mt-16 grid gap-8 lg:grid-cols-2">
          <ProductCard product={section.erp} tone="dark" onCta={onOpenErp} delay={0} />
          <ProductCard product={section.lifetide} tone="light" onCta={onRequestDemo} delay={120} />
        </div>
      </div>
    </section>
  );
}
